'use strict';

import { Pricelist } from './Pricelist';
import { Partition } from './Partition';
import { InvalidConfigurationError } from './InvalidConfigurationError';

class Manifestation {

    /**
     * @param {Partition} partition
     */
    constructor(partition) {

        /**
         * @type {Partition}
         * @private
         */
        this._partition = partition;

        /**
         * @type {string}
         * @private
         */
        this._type = '';
    }

    /**
     * @param {string} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @returns {string}
     */
    get dotsOrSquares() {
        return 'dotsOrSquares';
    }

    /**
     * @returns {string}
     */
    get opalFrostBand() {
        return 'opalFrostBand';
    }

    /**
     * @returns {string}
     */
    get opalFrostFull() {
        return 'opalFrostFull';
    }

    /**
     * @returns {number}
     */
    get totalInPence() {
        if (!this._partition.hasValidDimensions) {
            throw new InvalidConfigurationError();
        }

        switch (this._type) {
            case this.dotsOrSquares:
                return this._dotsOrSquaresTotalInPence();
            case this.opalFrostBand:
                return this._opalFrostBandInPence();
            case this.opalFrostFull:
                return this._opalFrostFullInPence();
            default:
                throw new InvalidConfigurationError();
        }
    }

    /**
     * @returns {number}
     */
    _dotsOrSquaresTotalInPence() {
        let linearMeters = this._calculateLinearMeters();
        return Math.ceil( linearMeters * Pricelist.get().manifestations.dotsOrSquares);
    }

    /**
     * @returns {number}
     */
    _opalFrostBandInPence() {
        let linearMeters = this._calculateLinearMeters();
        // Minimum charge of £250
        if (linearMeters < 12) {
            return 25000;
        }
        return Math.ceil(linearMeters * Pricelist.get().manifestations.opalFrostBand);
    }

    /**
     * @returns {number}
     */
    _opalFrostFullInPence() {
        if (!this._partition.hasValidDimensions) {
            throw new InvalidConfigurationError();
        }

        let surfaceArea = this._partition.glassSurfaceArea;
        // Minimum charge of £250
        if (surfaceArea < 12) {
            return 25000;
        }
        return Math.ceil(surfaceArea * Pricelist.get().manifestations.opalFrostFull);
    }

    /**
     * @returns {number}
     * @private
     */
    _calculateLinearMeters() {
        let linearMeters = 0;
        switch (this._partition.type) {
            case this._partition.inlineType:
                linearMeters = this._partition._widthWithWastage;
                break;
            case this._partition.cornerType:
                linearMeters = this._partition._widthWithWastage + this._partition._depthWithWastage;
                break;
            case this._partition.threeSidedType:
            case this._partition.tShapeType:
                linearMeters = this._partition._widthWithWastage + (this._partition._depthWithWastage * 2);
                break;
        }
        // Dimensions are in mm
        return Math.ceil(linearMeters / 1000);
    }
}

export { Manifestation };



// WEBPACK FOOTER //
// ./src/objects/Manifestation.js